export default {
  club_name: 'Villa Lidköping BK',
  club_name_short: 'villalidkoping',
  stadium_name: '',
  staging_url: 'https://villalidkoping.api.fangroup.io',
  prod_url: 'https://villalidkoping.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/villalidkoping',
  club_logo: '/assets/teams/villalidkoping.png',
  app_name: 'villalidkoping',
  websale_name: 'villalidkoping',
  ntb_team_id: 10059,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'villalidkoping',
  monolithEnabled: false,
  vat: 25,
};
